import { email, helpers, required } from "@vuelidate/validators";
import { computed, Ref, ref } from "vue";
import { useVuelidate } from "@vuelidate/core";

export default function useProductDesign(activeProduct: any, emit: any) {
  const phoneLengthBetween10And12 = helpers.withMessage(
    "Phone number must be between 10 and 12 digits",
    helpers.regex(/^\d{10,12}$/)
  );

  const loadingDesignRequest = ref(false);
  const openSaveDesignDialog = ref(false);
  const rules = {
    name: { required, max: 255 },
    lastName: { required, max: 255 },
    email: { required, email },
    phone: { phoneLengthBetween10And12 },
  };
  const userData = ref({
    email: "",
    phone: "",
    name: "",
    lastName: "",
  });
  const v$ = useVuelidate(rules, userData.value);

  const spinnerComputed = computed(() => {
    return loadingDesignRequest.value === true ? "pi pi-spin pi-spinner" : "";
  });

  const onSuccess = (
    userData: any,
    v$: any,
    loadingDesignRequest: Ref<boolean>,
    openSaveDesignDialog: Ref<boolean>
  ) => {
    loadingDesignRequest.value = false;
    openSaveDesignDialog.value = false;
    userData.value.email = "";
    v$.value.$reset();
  };

  const saveDesign = async () => {
    const result = await v$.value.$validate();
    if (result) {
      loadingDesignRequest.value = true;

      await emit(
        "designSaved",
        activeProduct,
        userData,
        v$,
        loadingDesignRequest,
        openSaveDesignDialog,
        onSuccess
      );
    }
  };
  return {
    v$,
    userData,
    loadingDesignRequest,
    openSaveDesignDialog,
    saveDesign,
    spinnerComputed,
  };
}
